import { render, staticRenderFns } from "./ListPlaces.vue?vue&type=template&id=de36d5a6&"
import script from "./ListPlaces.vue?vue&type=script&lang=js&"
export * from "./ListPlaces.vue?vue&type=script&lang=js&"
import style0 from "./ListPlaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports